'use client';

import { memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { CardStyle, CardType, ComposableCard, TileProps } from '../../newComposables';

export const GlowTile: ComponentMemo<TileProps> = memo(
    ({ children, TagName = 'a', image, className, content, direction, ...props }) => {
        return (
            <ComposableCard.Root type={CardType.Tile} direction={direction} {...props}>
                <ComposableCard.Container
                    TagName={TagName}
                    className={clsx(CardStyle.backgroundTile({ ...props }), className)}
                    {...props}
                >
                    <ComposableCard.Image {...image} />
                    <ComposableCard.Content hasImage={!!image} {...content}>
                        {children}
                    </ComposableCard.Content>
                </ComposableCard.Container>
            </ComposableCard.Root>
        );
    },
);

GlowTile.displayName = 'GlowTile';
